<template>
  <a
    v-if="showAsLink"
    :href="href"
    target="_blank"
    rel="noopener noreferrer"
    class="einvoice-adj-badge badge font-weight-bold"
    :class="[badgeClass, wrapperClass]"
    v-b-tooltip.hover="linkTitle"
    @click.stop="onLinkClick"
  >
    {{ badgeLabel }}
    <i class="fas fa-external-link-alt ml-1 einvoice-adj-badge__external" aria-hidden="true"></i>
  </a>
  <span
    v-else
    class="einvoice-adj-badge badge font-weight-bold"
    :class="[badgeClass, wrapperClass]"
  >
    {{ badgeLabel }}
  </span>
</template>

<script>
import {
  getEinvoiceAdjustmentDraftBadgeClass,
  getEinvoiceAdjustmentDraftBadgeLabel,
} from '../utils/adjustmentDraftBadge.utils'

export default {
  name: 'EinvoiceAdjustmentDraftBadge',
  props: {
    status: { type: String, required: true },
    linkable: { type: Boolean, default: false },
    href: { type: String, default: null },
    linkTitle: { type: String, default: null },
    wrapperClass: { type: String, default: '' },
  },
  computed: {
    showAsLink() {
      return this.linkable && Boolean(this.href)
    },
    badgeClass() {
      return getEinvoiceAdjustmentDraftBadgeClass(this.status)
    },
    badgeLabel() {
      return getEinvoiceAdjustmentDraftBadgeLabel(this.status)
    },
  },
  methods: {
    onLinkClick(event) {
      this.$emit('link-click', event)
    },
  },
}
</script>

<style lang="scss" scoped>
.einvoice-adj-badge {
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.2em 0.5em;
  border-radius: 0.25rem;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  text-decoration: none;

  &__external {
    font-size: 0.6rem;
  }
}

a.einvoice-adj-badge {
  cursor: pointer;

  &:hover {
    opacity: 0.85;
    text-decoration: none;
  }
}
</style>
